import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useLiterals } from '~/components/Literals'
import { useInitialLocale } from '~/components/useInitialLocale'

import actions, { TYPES } from '../actions'
import api from '../api'
import { extractSegmentation } from '../utils'

function selectState(state) {
  return state
}

function randMessage(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function getStockMessage(store, product, getLiteral) {
  if (store.featured) return store.featured.message

  if (!product || product.gtin === 'all' || !store.stats) return ''

  const stockLevel = store.stats[product.gtin]?.stockLevel

  if (!stockLevel) return ''

  switch (stockLevel) {
    case 1:
      return randMessage([getLiteral('2010'), getLiteral('2011')])
    case 2:
      return randMessage([getLiteral('2012')])
    case 3:
      return randMessage([getLiteral('2013'), getLiteral('2014')])
    default:
      return randMessage([getLiteral('2012')])
  }
}

function StoresPage({ position, location, match, closeDrawerProduct, config }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(selectState)
  const localeRefValue = useInitialLocale(location.search)

  const { getLiteral } = useLiterals()

  const getProduct = async (searchParams, gtin) => {
    let product

    if (gtin === 'todos') {
      return { gtin: 'all', name: getLiteral('1996') }
    }

    const products = store.app.searchProductResults || store.app.products

    if (products) {
      product = products.find((i) => i.gtin === gtin)
    }

    if (!product) {
      product = (await api.search({ ...searchParams, gtin, locale: localeRefValue.current }))[0]
    }

    return product
  }

  const handleSearchStores = async (gtin) => {
    const searchParams = position.getParams()

    let product
    try {
      // precisa do buscar o produto
      dispatch(actions.updateApp({ productsLoading: true, storesLoading: true }))
      product = await getProduct(searchParams, gtin)

      // delay custom
      await new Promise((resolve) => setTimeout(resolve, 3000))

      if (!product) {
        !config.showContextViewEstablishment &&
          dispatch(actions.snack.add({ id: Date.now(), message: getLiteral('1685') }))

        dispatch(actions.updateApp({ productsLoading: false, storesLoading: false }))

        return config.showContextViewStore ? history.replace('/produto/todos') : history.replace('/')
      }

      dispatch(
        actions.updateApp({
          view: TYPES.VIEW_STORES,
          currentProduct: product,
          productsLoading: false,
        }),
      )
    } catch (error) {
      console.error('Error', error)
    }

    try {
      let payload = { ...searchParams, gtins: product.gtin }
      const { stores, segmentation } = await api.getStores(payload)

      const parsedSegmentation = extractSegmentation(segmentation)

      dispatch(
        actions.storesSuccess({
          stores: stores.map((store) => ({
            ...store,
            stockMessage: getStockMessage(store, product, getLiteral) || '',
          })),
          segmentation: parsedSegmentation,
          gtin,
        }),
      )
    } catch (error) {
      if (position.user && Object.values(position.user).some(Boolean)) {
        dispatch(actions.dialog.add({ id: Date.now(), product, config, navigate: store.app.searchFor }))
      }
      dispatch(actions.storesNotFound({ gtin }))
    }
  }

  useEffect(() => {
    dispatch(actions.updateApp({ currentStore: null, view: TYPES.VIEW_STORES }))
    closeDrawerProduct()

    if (!position.user?.lat && !position.user?.lng) return

    handleSearchStores(match.params.gtin)
  }, [location.key, position.fetched, position.user])

  return null
}

export default StoresPage
